import React from "react";
import BoomCheckbox from "@alboompro/boom-components/data-entry/checkbox/";

const Checkbox = ({ name, updaterFn, label, currentValue, locale }) => (
  <BoomCheckbox
    onChange={() => updaterFn({ prop: name, value: !currentValue })}
    label={label[locale]}
    checked={currentValue}
    style={{ marginBottom: 10 }}
    labelStyle={{ fontSize: 10 }}
  />
)

export default Checkbox;
